import React, { useEffect, useRef, useState } from "react";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { call } from "../../assets/img";
import DateRange2 from "../../Component/DateRange/DateRange2";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";

import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const Commission = () => {

  const { kv, set } = useStoreKv();
  const CommissionAmount = kv.commissionamount || [];
  const commissionSales = kv.commissionsales || [];
  const commissionlist = kv.commissionlist || [];

  const [page, setPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [totalCommission, setTotalCommission] = useState(0);
  const [popup, setPopup] = useState(false);
  const [popup1, setPopup1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [salesAmount, setSalesAmount] = useState(commissionSales);
  const [commissionAmount, setCommissionAmount] = useState(CommissionAmount);
  const [search, setSearch] = useState('');
  const [owners, setOwners] = useState(commissionlist);
  const [totalUser, setTotalUser] = useState(0);
  const [pagecount, setPagecount] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const lastRequestId = useRef(0);

  const getTodayFormatted = () => {
    const date = new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const [selectedDate, setSelectedDate] = useState(getTodayFormatted());

  const getList2 = async () => {
    try {
      // setLoading(true);
      // setIsLoading(true)
      const res = await get(`${URLS.MASTER}?type=4`);
//       console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setCommissionAmount(`${'₹'} ${res?.data?.commission_amount}`);
        setSalesAmount(`${'₹'} ${res?.data?.sales_amount}`);
        set('commissionamount', `${'₹'} ${res?.data?.commission_amount}`);
        set('commissionsales', `${'₹'} ${res?.data?.sales_amount}`);
      } else {
        setCommissionAmount(`${'₹'} 0`);
        setSalesAmount(`${'₹'} 0`);
        set('commissionamount', `${'₹'} 0`);
        set('commissionsales', `${'₹'} 0`);
      }
    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
    } finally {
      // setLoading(false);
      // setIsLoading(false);
    }
  };

  const getList = async (page = 1, filters = [], currentRequestId) => {
    // setLoading(true);

    try {
      const query = filters.length ? `&${filters.join("&")}` : "";
      const res = await get(`${URLS.COMMISSIONHITORY}?page=${page}${query}`);

      if (currentRequestId !== lastRequestId.current) return;

//       console.log("res client list", res);

      if (res?.status === "success") {
        setOwners(res?.data || []);
        set('commissionlist', res?.data || []);
        setTotalCommission(res?.commission_total || 0);
        setTotalUser(res?.pagination?.total_count);
        setPagecount(res?.pagination?.total_pages);
        // setLoading(false)
      } else {
        setOwners([]);
        set('commissionlist', []);
        setTotalCommission(0);
        setTotalUser(0);
        setPagecount(0);
        // setLoading(false)
      }
    } catch (error) {
      if (currentRequestId !== lastRequestId.current) return;
      console.error("Error fetching client list:", error);
      // setLoading(false)
      setOwners([]);
    }
  };

  useEffect(() => {
    const currentRequestId = ++lastRequestId.current;

    let filters = [];
    if (search) filters.push(`mobile=${encodeURIComponent(search)}`);
    if (selectedDate)
      filters.push(`date=${encodeURIComponent(selectedDate)}`);

    getList(page, filters, currentRequestId);
    getList2();
  }, [selectedDate, search, page]);

  const handleSearch = () => {
    setSearch(mobile);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " From Phone No",
        accessor: "client_mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " To Phone No",
        accessor: "related_client_mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: (
          <span>
            Buy
            <br />
            Amount
          </span>
        ),
        accessor: "total_amount",
        Cell: ({ value, row }) => {
          return <p>{`₹${value}`}</p>;
        },
      },
      {
        Header: (
          <span>
            Commission
            <br />
            Amount
          </span>
        ),
        accessor: "commission_amount",
        Cell: ({ value, row }) => {
          return <p>₹&nbsp;{value}</p>;
        },
      },
    ],
    []
  );


  const handleInputChange = (e, setter) => {
    let value = e.target.value;
    if (!value.startsWith("₹")) {
      value = "₹" + value.replace(/₹/g, "");
    }

    setter(value);
  };

  const handleUpdateCommission = async () => {
    try {
      setLoading1(true);
      const payload = {
        id: 4,
        sales_amount: salesAmount.replace('₹', ''),
        commission_amount: commissionAmount.replace('₹', ''),
      };
      const res = await post(`${URLS.COMMISSIONUPDATE}`, payload);
//       console.log("Update response:", res);

      if (res?.status === "success") {
        setLoading1(false);
        setPopup1(false)
        Toast(" Updated successfully!");
      } else {
        Toast(res?.message || "Update failed!");
        setLoading1(false);
      }
    } catch (err) {
      Toast("Error updating ");
      setLoading1(false);
      console.error(err);
    } finally {
      setLoading1(false);
    }
  };

  const [browsHeader, setBrowsHeader] = useState(true);

  const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      const visibleHeight = window.visualViewport?.height || window.innerHeight;

      // 🔹 Skip logic on first run
      if (isFirstRun.current) {
        isFirstRun.current = false;
        setBrowsHeader(true);
        return;
      }

      // 🔻 Viewport reduced (keyboard / browser UI)
      if (visibleHeight < maxHeight.current) {
        setBrowsHeader(true);
      }
      // 🔺 Viewport restored
      else {
        maxHeight.current = visibleHeight;
        setBrowsHeader(false);
      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, [browsHeader]);


  return (
    <div style={{
      position: "relative",
      overflow: 'hidden'
    }} className="dashRightView marginScrolls d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div style={{ paddingTop: 0, paddingBottom: 50 }} className="container_overalls">
          <div className="d-flex ac-js col-md-5  my-3">
            <label className=" f3  fs-xs-18  fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Commission Details
            </label>
          </div>
          <div className="col-md-5">
            <div className="my-3 sale_value">
              <div className="table-like2">
                <div className="table-row2">
                  <div style={{ borderTopLeftRadius: 20 }} className="table-cell2">
                    <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                      Sales Amount
                    </h4>
                  </div>
                  <div style={{ borderTopRightRadius: 20 }} className="table-cell2">
                    <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                      Commission Amount
                    </h4>
                  </div>
                </div>

                <div className="table-row3">
                  <div className="table-cell2">
                    <input
                      type="text"
                      value={salesAmount}
                      onChange={(e) => handleInputChange(e, setSalesAmount)}
                      className="f2 text-center placholdercolorchanges2 form-control3 border-0 fs-xs-15 fs-sm-13 fs-md-15 fs-lg-18 fs-xl-19 fs-xxl-22"
                    />
                  </div>

                  <div className="table-cell2">
                    <input
                      type="text"
                      value={commissionAmount}
                      onChange={(e) => handleInputChange(e, setCommissionAmount)}
                      className="f2 text-center placholdercolorchanges2 form-control3 border-0 fs-xs-15 fs-sm-13 fs-md-15 fs-lg-18 fs-xl-19 fs-xxl-22"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-5 my-3">
            <button onClick={() => setPopup1(true)} className="add-button w-100 f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white">Update</button>
          </div>

          <div className="announcement_date mb-3 col-md-5">
            <DateRange2 selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
          </div>
          <div className="form-group  text-start my-3 col-md-5">
            <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">
              Mobile Number
            </label>
            <div className="login-input1 mt-1">
              {/* <p className="f3  fs-sm-14 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17">
              +91
            </p> */}
              <input
                value={mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setMobile(value);
                  }
                }}
                type="tel"
                placeholder="Enter your mobile number"
                required
                maxLength={10}
                className="placholdercolorchanges2"
              />

              <img src={call} alt="call icon" style={{ marginRight: 12, width: 18, top: -1, position: 'relative' }} />
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>

          <div className="col-md-5 my-3">
            <button onClick={handleSearch} className="add-button w-100 f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white">
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                <span style={{ top: -1.5, position: 'relative' }}>Search</span>
              )}

            </button>
          </div>

          <Table
            columns={columns}
            pageno={page}
            setPageno={setPage}
            pagecount={pagecount}
            totalPages={totalUser}
            data={owners}
            tableHeight={'60%'}
            show={true}
            loading={loading}
          />


        </div>
        <div style={{
          position: 'fixed',
          bottom: 100,
          background: "#F0EDE6",
          width: "100%",
          justifyContent: "center",
          padding: "10px 0",
          marginBottom: 2,
          right: 0
        }} className="col-md-5 w-100 d-flex totoAmmut">
          <div className="total_amount">
            <h4 className="f4 text-center  fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17">
              Total Commission amount: ₹ {totalCommission}
            </h4>
          </div>
        </div>



        {popup && (
          <div className="img-popup-design1">
            <div className="img-popup1">
              <button className="close-btn" onClick={() => setPopup(false)}>
                ×
              </button>

              <textarea
                className="input-box3"
                name="reason"
                placeholder="Type your reason here..."
                rows="4"
              />

              <div className="d-flex ac-jc px-1 py-1">
                <button
                  onClick={() => setPopup(false)}
                  className="add-button w-100 f2 w-45 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  Block User
                </button>
              </div>
            </div>
          </div>
        )}
        {/* {loading && <Loader />} */}
        {popup1 && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Update?
              </p>
              <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                <button onClick={() => { setPopup1(false) }} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleUpdateCommission}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading1 ? <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white" }}
                    ></span>
                  </> : 'Yes'}
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};

export default Commission;
